<template>
  <Header
    :isFromClass="true"
    :p_isLogin="c_isLogin"
    :p_gotoLogin="gotoLogin"
    :p_logout="logout"
    :UserInfo="mg_userInfo"
    :p_isInCnIframe="ms_isInCnIframe"
    v-if="!fromwechat"
    :RedirectUrl="redirectUrl"
  />
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
// import { Header } from '@handl-web/vue-pz/Header';
// console.log(Header);
// import Header from '@shared-components/Header.vue';
import {
  LOGIN_PAGE,
  LANDING_PAGE,
  REFERRAL_PAGE,
  TRAIL_LESSON_20426_PAGE,
  DASHBOARD_PAGE,
} from '../constants/routes';
import { REDIRECT_URLS, ARTICLES_PAGE } from '../constants';

export default {
  name: 'SharedHeader',

  components: {
    // Header,
  },

  data: () => {
    return {
      redirectUrl: {
        ...REDIRECT_URLS,
        REFERRAL_PAGE,
        DASHBOARD_PAGE,
        TRAIL_LESSON_20426_PAGE,
        //ARTICLES_PAGE,
      },
      fromwechat: window.sessionStorage.getItem('fromwechat'),
    };
  },

  computed: {
    ...mapState({
      ms_isInCnIframe: 'isInCnIframe',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },

    c_avatar() {
      return this.mg_userInfo.avatar;
    },

    c_nickname() {
      return this.mg_userInfo.nickname;
    },

    c_bonusPoint() {
      return this.mg_userInfo.bonusPoint;
    },

    c_hasNewMessages() {
      return this.mg_userInfo.hasNewMessages;
    },

    c_hasQaNewAAndC() {
      return Boolean(this.mg_userInfo.totalAandC);
    },

    c_showOldVersion() {
      return this.mg_userInfo.showOldVersion;
    },
  },

  methods: {
    ...mapActions({
      ma_logout: 'logout',
    }),

    gotoLogin() {
      this.$router.push(LOGIN_PAGE);
    },

    async logout() {
      await this.ma_logout();
      //this.$router.push(LANDING_PAGE);
      window.location.href = REDIRECT_URLS.LANDING_PAGE
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
